import { TableCell, TableRow } from 'semantic-ui-react';
import { Key, Trash } from '@phosphor-icons/react';
import styled from 'styled-components';
import { ActionEditDots, ActionMenuItem } from '../../../components';
import { CommonUtility } from '../../../utility';

const ActionEditTableRow = styled(TableRow)`
  position: relative;

  .action-container {
    margin: auto;
    background: transparent;
    right: 10px;
    bottom: 0;
  }

  &:hover {
    img.m-auto {
      opacity: 0.3;
    }
    .action-container {
      opacity: 1 !important;
    }
  }
`;

export function UserRow({ item, remove, toggle2FA, isAdmin }) {
  return (
    <ActionEditTableRow>
      <TableCell>{item.firstName}</TableCell>
      <TableCell>{item.email}</TableCell>
      <TableCell>{CommonUtility.toTitleCase(item.role)}</TableCell>
      <TableCell>
        <ActionEditDots preventChangingBg on="hover" position="left center">
          <ActionMenuItem className="danger" onClick={() => remove(item)}>
            <Trash />
            Delete
          </ActionMenuItem>
          {isAdmin && (
            <ActionMenuItem
              className={!item.bypass_2fa ? 'danger' : ''}
              onClick={() => toggle2FA(item)}
            >
              <Key />
              Turn 2FA {!item.bypass_2fa ? 'Off' : 'On'}
            </ActionMenuItem>
          )}
        </ActionEditDots>
      </TableCell>
    </ActionEditTableRow>
  );
}
